import { createIcon } from './createIcon'

export const SingleChevronCircleIcon = createIcon({
  displayName: 'SingleChevronCircleIcon',
  viewBox: '0 0 16 16',
  path: [
    <path
      d="M5.67089 8.73083L8.07089 6.33083L10.4709 8.73083"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
  ],
})
